// NTFSButtons.js
import React from "react";
import { Button } from "@material-ui/core";
import { ColoredActionButton } from "../../../common/buttons";

function NTFSButtons({
  classes,
  toggleDrawer,
  handleSaveActions,
  handleDownloadActions,
  isEditMode,
  ntfsConfigurationCheck,
  iconMap,
  handleAgentDownloadActions,
}) {
  return (
    <div className="dataSourceButtonsContainer">
      <ColoredActionButton
        className={classes.cancelButtonCustomStyles}
        onClick={(event) => toggleDrawer(false, event)}
      >
        Cancel
      </ColoredActionButton>
      <span
        title={
          !ntfsConfigurationCheck && !isEditMode
            ? `Select the "NTFS configuration is done" checkbox to enable Save.`
            : ""
        }
        className={
          !ntfsConfigurationCheck && !isEditMode ? "cursorNotAllowed" : ""
        }
      >
        <Button
          type="submit"
          variant="contained"
          disabled={!ntfsConfigurationCheck && !isEditMode}
          color="primary"
          className={classes.saveButtonCustomStyles}
          onClick={(event) => handleSaveActions(event)}
        >
          Save
        </Button>
      </span>
      <span
        title={
          !isEditMode
            ? "The configuration can be downloaded after the file has been saved."
            : ""
        }
        className={!isEditMode ? "cursorNotAllowed" : ""}
      >
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={!isEditMode}
          className={classes.downloadButtonCustomStyles}
          onClick={(event) => handleDownloadActions(event)}
        >
          Download Configuration
        </Button>
      </span>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className={classes.downloadButtonCustomStyles}
        onClick={(event) => handleAgentDownloadActions(event)}
      >
        Download Agent
      </Button>
    </div>
  );
}

export default NTFSButtons;
